var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.832031 2C0.832031 1.60218 0.990066 1.22064 1.27137 0.93934C1.55268 0.658035 1.93421 0.5 2.33203 0.5C2.72986 0.5 3.11139 0.658035 3.39269 0.93934C3.674 1.22064 3.83203 1.60218 3.83203 2C3.83203 2.39782 3.674 2.77936 3.39269 3.06066C3.11139 3.34196 2.72986 3.5 2.33203 3.5C1.93421 3.5 1.55268 3.34196 1.27137 3.06066C0.990066 2.77936 0.832031 2.39782 0.832031 2ZM0.832031 8C0.832031 7.60218 0.990066 7.22064 1.27137 6.93934C1.55268 6.65804 1.93421 6.5 2.33203 6.5C2.72986 6.5 3.11139 6.65804 3.39269 6.93934C3.674 7.22064 3.83203 7.60218 3.83203 8C3.83203 8.39782 3.674 8.77936 3.39269 9.06066C3.11139 9.34196 2.72986 9.5 2.33203 9.5C1.93421 9.5 1.55268 9.34196 1.27137 9.06066C0.990066 8.77936 0.832031 8.39782 0.832031 8ZM0.832031 14C0.832031 13.6022 0.990066 13.2206 1.27137 12.9393C1.55268 12.658 1.93421 12.5 2.33203 12.5C2.72986 12.5 3.11139 12.658 3.39269 12.9393C3.674 13.2206 3.83203 13.6022 3.83203 14C3.83203 14.3978 3.674 14.7794 3.39269 15.0607C3.11139 15.342 2.72986 15.5 2.33203 15.5C1.93421 15.5 1.55268 15.342 1.27137 15.0607C0.990066 14.7794 0.832031 14.3978 0.832031 14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalDots);
export default __webpack_public_path__ + "static/media/vertical-dots.5379ba4c1f6df323d50193bbc18a4f77.svg";
export { ForwardRef as ReactComponent };